import cookies from "js-cookie";

/** Le cookie i18next porte les codes maison : `du` = néerlandais, `fn` = français. */
const LOCALE_MAP = { du: "nl-BE", fn: "fr-BE", en: "en-GB" };

export const currentLocale = () => LOCALE_MAP[cookies.get("i18next")] || "en-GB";

export const formatCurrency = (value) => {
  const amount = Number.parseFloat(value);
  if (!Number.isFinite(amount)) return "—";
  return new Intl.NumberFormat(currentLocale(), {
    style: "currency",
    currency: "EUR",
  }).format(amount);
};

/** Les kilos s'affichent avec une décimale, comme dans la maquette (« 3,4 »). */
export const formatKilos = (value) => {
  const amount = Number.parseFloat(value);
  if (!Number.isFinite(amount)) return "—";
  return new Intl.NumberFormat(currentLocale(), {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(amount);
};

export const formatShortDate = (date) => {
  if (!date) return "—";
  return new Intl.DateTimeFormat(currentLocale(), {
    day: "numeric",
    month: "short",
  }).format(date);
};

export const formatLongDate = (date) => {
  if (!date) return "—";
  return new Intl.DateTimeFormat(currentLocale(), {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};

export const formatDayTime = (date) => {
  if (!date) return "—";
  return new Intl.DateTimeFormat(currentLocale(), {
    weekday: "long",
    day: "numeric",
    month: "long",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

export const formatMonthYear = (date) => {
  if (!date) return "—";
  return new Intl.DateTimeFormat(currentLocale(), {
    month: "long",
    year: "numeric",
  }).format(date);
};

/** Initiales pour les pastilles d'avatar. Deux lettres maximum. */
export const initialsOf = (name = "") => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "—";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

